import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | PH Therapy</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to PH Therapy to find expert exercise physiology and rehabilitation." />
      </Helmet>
      <Header />
      <main id="not-found-page" className="content-page">
        <div className="container not-found-content">
          <h1>Page not found</h1>
          <p>Sorry, the page you're looking for doesn't exist or has been moved.</p>
          <Link to="/" className="not-found-cta">
            Return to Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
